import axios from 'axios'
import { IhLogUrl } from '@/api/config'
import { showErrorMsg } from '@/util/msgConst'

// 是否开启数字化平台采集数据
const collectionFlag = true

/**
 * 数字化平台采集接口调用错误
 */
export function errorCollection(module, operation, response) {
  if (!collectionFlag) {
    return
  }
  const url = IhLogUrl + '/system/log/upload'
  let operationType = 'USER_ERROR'
  let operationLog = '系统异常'
  if (response.status !== 200 || response.data.state === 500) {
    operationType = 'SYSTEM_ERROR'
    if (response.data.state === 500) {
      operationLog = '系统异常:' + response.data.data
    }
  } else {
    // state等于-1时为前端自定义错误提示语
    if (response.data.state !== -1) {
      let state = response.data.state + ''
      operationLog = showErrorMsg(state)
    } else {
      operationLog = response.data.msg
    }
    if (response.data.operationType) {
      operationType = response.data.operationType
    }
  }
  let params = {
    dataType: 'platform_operation_record',
    data: [
      {
        logTime: new Date().getTime(),
        platform: 'GK4',
        operationType: operationType,
        module: module,
        operation: operation,
        operationLog: operationLog,
      },
    ],
  }
  axios({
    method: 'post',
    url: url,
    data: params,
  })
}

/**
 * 数字化平台采集登录信息
 */
export function loginCollection(loginResult, logTime) {
  if (!collectionFlag) {
    return
  }
  let data = [
    {
      logTime: logTime,
      platform: 'GK4',
      loginOS: getOS(),
      appVersion: getBrowserInfo(),
      loginAddress: '',
      loginResult: loginResult,
    },
  ]
  let loginFailRecord = JSON.parse(localStorage.getItem('LOGIN_FAIL_RECORD'))
  if (!loginFailRecord) {
    loginFailRecord = []
  }
  if (loginResult === 'FAIL') {
    loginFailRecord.push(logTime)
    localStorage.setItem('LOGIN_FAIL_RECORD', JSON.stringify(loginFailRecord))
    return
  } else if (loginFailRecord.length > 0) {
    for (let date of loginFailRecord) {
      data.push({
        logTime: date,
        platform: 'GK4',
        loginOS: getOS(),
        appVersion: getBrowserInfo(),
        loginAddress: '',
        loginResult: 'FAIL',
      })
    }
  }
  const url = IhLogUrl + '/system/log/upload'
  let params = {
    dataType: 'platform_login_record',
    data: data,
  }
  axios({
    method: 'post',
    url: url,
    data: params,
  }).then(res => {
    if (res.status === 200 && !!res.data && res.data.state === 0) {
      localStorage.removeItem('LOGIN_FAIL_RECORD')
    }
  })
}

/**
 * 获取浏览器信息
 */
function getBrowserInfo() {
  let agent = navigator.userAgent.toLowerCase()
  let regStr_ie = /msie [\d.]+;/gi
  let regStr_ff = /firefox\/[\d.]+/gi
  let regStr_chrome = /chrome\/[\d.]+/gi
  let regStr_saf = /safari\/[\d.]+/gi
  //IE
  if (agent.indexOf('msie') >= 0) {
    return agent.match(regStr_ie)[0]
  }
  //firefox
  if (agent.indexOf('firefox') >= 0) {
    return agent.match(regStr_ff)[0]
  }
  //Safari
  if (agent.indexOf('safari') >= 0 && agent.indexOf('chrome') < 0) {
    return agent.match(regStr_saf)[0]
  }
  //Chrome
  if (agent.indexOf('chrome') >= 0) {
    return agent.match(regStr_chrome)[0]
  } else {
    return ''
  }
}

/**
 * 获取操作系统信息
 */
function getOS() {
  let os = 'Others'
  let agent = navigator.userAgent.toLowerCase()
  if (agent.indexOf('android') >= 0 || agent.indexOf('linux') >= 0) {
    os = 'Android'
  } else if (agent.indexOf('iphone') >= 0 || agent.indexOf('ipad') >= 0) {
    os = 'IOS'
  } else if (agent.indexOf('windows') >= 0) {
    if (agent.match(/windows nt [\d.]+;/gi)[0]) {
      os = agent.match(/windows nt [\d.]+;/gi)[0].replace(/;/g, '')
    }
  }
  return os
}
